var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedbackIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0833 8.75002V8.33335C17.0833 5.19065 17.0833 3.61931 16.107 2.643C15.1307 1.66669 13.5594 1.66669 10.4166 1.66669H9.58335C6.44071 1.66669 4.86938 1.66669 3.89307 2.64299C2.91676 3.61929 2.91675 5.19062 2.91672 8.3333L2.91669 12.0834C2.91666 14.8229 2.91665 16.1927 3.67325 17.1146C3.81179 17.2834 3.96657 17.4382 4.13537 17.5768C5.05733 18.3334 6.4271 18.3334 9.1666 18.3334",
    stroke: "#50566C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 5.83331H13.75",
    stroke: "#50566C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 10H11.25",
    stroke: "#50566C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0833 16.6667V14.1667C17.0833 12.9755 15.9641 11.6667 14.5833 11.6667C13.2026 11.6667 12.0833 12.9755 12.0833 14.1667V17.0834C12.0833 17.7737 12.643 18.3334 13.3333 18.3334C14.0236 18.3334 14.5833 17.7737 14.5833 17.0834V14.1667",
    stroke: "#50566C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackIcon);
export default __webpack_public_path__ + "static/media/feedback_icon.9cf1e7958c69e983e15fb2fbbe63be62.svg";
export { ForwardRef as ReactComponent };